/*                                              */

import { DEV } from 'esm-env';
import { add_owner } from './dev/ownership.js';
import { lifecycle_outside_component } from '../shared/errors.js';
import { source } from './reactivity/sources.js';
import {
	active_effect,
	active_reaction,
	set_active_effect,
	set_active_reaction,
	untrack
} from './runtime.js';
import { effect, teardown } from './reactivity/effects.js';
import { legacy_mode_flag } from '../flags/index.js';

/*                                  */
export let component_context = null;

/*                                           */
export function set_component_context(context) {
	component_context = context;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export let dev_current_component_function = null;

/*                                           */
export function set_dev_current_component_function(fn) {
	dev_current_component_function = fn;
}

/**
 *
 *
 *
 *
 *
 *
 */
export function getContext(key) {
	const context_map = get_or_init_context_map('getContext');
	const result = /*            */ (context_map.get(key));
	return result;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function setContext(key, context) {
	const context_map = get_or_init_context_map('setContext');

	if (DEV) {
		/*                                                                      */
		/*                                                                     */
		/*                                                                   */
		/*                             */
		untrack(() => add_owner(context, null, true));
	}

	context_map.set(key, context);
	return context;
}

/**
 *
 *
 *
 *
 *
 */
export function hasContext(key) {
	const context_map = get_or_init_context_map('hasContext');
	return context_map.has(key);
}

/**
 *
 *
 *
 *
 *
 *
 */
export function getAllContexts() {
	const context_map = get_or_init_context_map('getAllContexts');
	return /*            */ (context_map);
}

/**
 *
 *
 *
 *
 */
export function push(props, runes = false, fn) {
	var ctx = (component_context = {
		p: component_context,
		c: null,
		d: false,
		e: null,
		m: false,
		s: props,
		x: null,
		l: null
	});

	if (legacy_mode_flag && !runes) {
		component_context.l = {
			s: null,
			u: null,
			r1: [],
			r2: source(false)
		};
	}

	teardown(() => {
		/*                           */ (ctx).d = true;
	});

	if (DEV) {
		/*                 */
		component_context.function = fn;
		dev_current_component_function = fn;
	}
}

/**
 *
 *
 *
 */
export function pop(component) {
	const context_stack_item = component_context;
	if (context_stack_item !== null) {
		if (component !== undefined) {
			context_stack_item.x = component;
		}
		const component_effects = context_stack_item.e;
		if (component_effects !== null) {
			var previous_effect = active_effect;
			var previous_reaction = active_reaction;
			context_stack_item.e = null;
			try {
				for (var i = 0; i < component_effects.length; i++) {
					var component_effect = component_effects[i];
					set_active_effect(component_effect.effect);
					set_active_reaction(component_effect.reaction);
					effect(component_effect.fn);
				}
			} finally {
				set_active_effect(previous_effect);
				set_active_reaction(previous_reaction);
			}
		}
		component_context = context_stack_item.p;
		if (DEV) {
			dev_current_component_function = context_stack_item.p?.function ?? null;
		}
		context_stack_item.m = true;
	}
	/*                                                         */
	/*                                                            */
	return component || /*            */ ({});
}

/*                     */
export function is_runes() {
	return !legacy_mode_flag || (component_context !== null && component_context.l === null);
}

/**
 *
 *
 */
function get_or_init_context_map(name) {
	if (component_context === null) {
		lifecycle_outside_component(name);
	}

	return (component_context.c ??= new Map(get_parent_context(component_context) || undefined));
}

/**
 *
 *
 */
function get_parent_context(component_context) {
	let parent = component_context.p;
	while (parent !== null) {
		const context_map = parent.c;
		if (context_map !== null) {
			return context_map;
		}
		parent = parent.p;
	}
	return null;
}
